import React, {useContext, useState} from "react";

import EditView from "../../component/EditView";
import Texto from "../../component/form/texto/Texto";

import TipoRestaurante from "../../model/TipoRestaurante";
import {MensagemContext} from "../../context/MensagemContext";
import {MensagemContextType} from "../../context/MensagemContextType";
import FormUtils from "../../utils/FormUtils";
import {TooltipPosition} from "../../component/form/TooltipPosition";
import useToken from "../../hook/useToken";
import {useNavigate} from "react-router-dom";
import rest from "../../utils/EnvConfig";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import SemPermissao from "../erro/SemPermissao";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";
import {useKeycloak} from "../../keycloak/useKeycloak";

function TipoRestauranteEdit() {
    const {error} = useContext(MensagemContext) as MensagemContextType;
    const [entidade, setEntidade] = useState<TipoRestaurante>({});

    const editEntidade = (data: TipoRestaurante) => {
        setEntidade(data);
    }

    const entidadeOnChangeHandler = (e: any) => {
        setEntidade({...entidade, [e.target.id]: e.target.value});
    }

    const validar = async (): Promise<boolean> => {
        if (!entidade.nomeAtividade) {
            FormUtils.invalidarComponente(error, "Descrição é obrigatório.");
            return false;
        }

        return true;
    }

    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}
                             forbiddenFallback={<SemPermissao />}>
                <EditView title={"Tipo restaurante"}
                          id={`${rest.tipoRestaurante}`}
                          entidade={entidade}
                          onValidationHandler={validar}
                          entidadeUseStateFunction={editEntidade}>

                    <Texto id={"nomeAtividade"} value={entidade.nomeAtividade}
                           label={"* Descrição"} size={"100%"} maxLength={20}
                           tooltip={"Informe a descrição"} tooltipPosition={TooltipPosition.TOP}
                           onChangeHandler={entidadeOnChangeHandler}/>

                </EditView>
            </RoleBasedAccess>
        </>
    );
}

export default TipoRestauranteEdit;